var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackgroundProfileThree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1828 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_16864)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_16864)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -58,
    y: -400,
    width: 1944,
    height: 1164
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18px)",
      clipPath: "url(#bgblur_1_47_16864_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 15H1802C1810.28 15 1817 21.7157 1817 30V157H11V30C11 21.7157 17.7157 15 26 15Z",
    stroke: "#A8F0E7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_47_16864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1850 728H-22V-364H1850V728Z",
    fill: "url(#paint0_linear_47_16864)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1850 288.183H880V-184.953L1280.41 -416.228H1850V288.183Z",
    fill: "url(#paint1_linear_47_16864)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1850 288.183H1161.94V-22.103L1586.17 -267.135L1850 -114.749V288.183Z",
    fill: "url(#paint2_linear_47_16864)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1586.17 -81.8328L1718.09 -5.63995L1850 70.5528V222.931V288.183H1322.36V222.931V70.5528L1454.27 -5.63995L1586.17 -81.8328Z",
    fill: "#1EAE9B"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_16864",
    x: -4,
    y: 0,
    width: 1840,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_16864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_16864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_47_16864_clip_path",
    transform: "translate(58 400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 15H1802C1810.28 15 1817 21.7157 1817 30V157H11V30C11 21.7157 17.7157 15 26 15Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_16864",
    x1: 1942.5,
    y1: -1032.5,
    x2: -117.239,
    y2: 305.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_16864",
    x1: 1485.8,
    y1: -462.85,
    x2: 920.337,
    y2: 622.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EAE9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8F0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_16864",
    x1: 1505.97,
    y1: -523.846,
    x2: 1505.97,
    y2: 288.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EAE9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_16864"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 30C10 21.1634 17.1634 14 26 14H1802C1810.84 14 1818 21.1634 1818 30V158H10V30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_47_16864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1872,
    height: 1092,
    fill: "white",
    transform: "translate(-22 -364)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackgroundProfileThree);
export default __webpack_public_path__ + "static/media/ic-background-profile-three.859eb577b508bf9b553915bb6566a27c.svg";
export { ForwardRef as ReactComponent };